// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPayment = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M11.234 16.93c-1.498-.224-2.534-1.134-2.8-2.758l1.61-.14c.182.952.896 1.54 2.016 1.54 1.092 0 1.736-.588 1.736-1.456 0-.882-.686-1.12-1.736-1.428l-.714-.224c-1.694-.504-2.618-1.246-2.618-2.772 0-1.386.938-2.45 2.506-2.702V5.408h1.61v1.596c1.4.252 2.254 1.19 2.436 2.506l-1.596.14c-.182-.812-.7-1.274-1.722-1.274-.952 0-1.512.504-1.512 1.218 0 .812.644 1.064 1.708 1.414l.658.21c1.652.546 2.688 1.12 2.688 2.8 0 1.554-1.064 2.632-2.66 2.898v1.722h-1.61z" />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconPayment;
